// export type ButtonType = 'primary' | 'secondary' | 'no-style' | 'inverted' | 'white' | 'black';

export enum ButtonType {
  primary = 'primary',
  secondary = 'secondary',
  // tertiary = 'tertiary',
  quaternary = 'quaternary',
  quinary = 'quinary',
}
